import { Button } from "@headlessui/react";
import { CSSProperties, MouseEventHandler } from "react";

export const TextButton = ({
  children,
  className,
  onClick,
  disabled,
  style,
  "data-testid": dataTestId,
  ...otherProps
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  disabled?: boolean;
  "data-testid"?: string;
  [key: string]: any;
}) => (
  <>
    <Button
      data-testid={dataTestId}
      className={`py-2 px-8 rounded bg-white text-blue-700 data-[hover]:brightness-125 data-[active]:brightness-125 ${className}`}
      onClick={onClick}
      style={style}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </Button>
  </>
);
